"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.relatedGuardiansResultFactory = void 0;
const Factory = require("factory.ts");
const Accounts_1 = require("../Accounts");
const related_profile_factory_1 = require("./related-profile.factory");
exports.relatedGuardiansResultFactory = Factory.Sync.makeFactory({
    id: Factory.each(i => i + 1),
    user: Accounts_1.userFactory.build(),
    profiles: related_profile_factory_1.relatedProfileFactory.buildList(2),
});
